import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../shared/services/configuration.service';
import { ScoreModel } from '../models/score.model';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class ScoreService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.supplierApiUrl}api`
  }

  getContractorsScore(): Observable<ScoreModel[]> {
    return this.http.get<ScoreModel[]>(
      `${this.backUrl}/providers/scores`
    );
  }
}
